const vehicleDescriptions = {
  "Suzuki Swift":
    "A compact automatic hatchback with seating for five and space for two bags. Its practical size makes it a convenient choice for city driving, local trips and easier parking around Perth.",
  "Mazda CX3":
    "A compact automatic SUV with seating for five and space for three bags. It suits city travel, everyday driving and short trips where a little more room is helpful.",
  "Toyota Corolla":
    "A practical automatic sedan with seating for five and space for four bags. It is a comfortable option for daily travel, business trips and longer drives from Perth.",
  "KIA Carnival 8 Seater":
    "A spacious automatic people mover with seating for eight and space for five bags. It is well suited to families and groups travelling together around Perth.",
  "Outlander 7 Seater":
    "A seven-seat automatic SUV with space for four bags. Its flexible passenger capacity makes it a useful option for families, groups and longer journeys.",
  "Mazda CX8":
    "A seven-seat automatic SUV with space for four bags. It provides practical room for family travel, group trips and longer drives around Perth and Western Australia.",
  "Toyota Hilux":
    "A five-seat automatic ute with space for up to six bags. It is a practical choice for customers who need passenger seating together with additional luggage capacity.",
};

export const getVehicleDescription = (car) =>
  vehicleDescriptions[car?.name] ||
  car?.description ||
  `${car?.name || "This vehicle"} is available for rental from TAK8 Car Rental in East Perth.`;

export default vehicleDescriptions;
